var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from "clsx";
import React from "react";
import styles from "./Loader.module.scss";
/** @deprecated use Loading instead */
export const LoaderIcon = (_a) => {
    var { bgColor = "#f2f4f5", color = "#238FF3", size } = _a, props = __rest(_a, ["bgColor", "color", "size"]);
    return (React.createElement("div", { className: clsx(styles.Wrapper, props.className), style: {
            width: size,
            height: size,
        } },
        React.createElement("svg", Object.assign({}, props, { width: size, height: size, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
            React.createElement("path", { d: "M8.99991 15.3C12.4738 15.3 15.3 12.4739 15.3 9.00018C15.3 5.52625 12.4738 2.7 8.99991 2.7C5.52613 2.7 2.7 5.52625 2.7 9.00018C2.7 12.4739 5.52613 15.3 8.99991 15.3ZM8.99991 18C4.03242 18 0 13.9678 0 9.00018C0 4.02734 4.03242 0 8.99991 0C13.9726 0 18 4.02734 18 9.00018C18 13.9678 13.9726 18 8.99991 18Z", fill: bgColor }),
            React.createElement("path", { d: "M0 9.30209L2.648 9.36209C2.724 5.53709 5.241 2.73909 9.064 2.66809L9.181 0.121094C6.75683 0.155723 4.44167 1.13412 2.72735 2.84844C1.01303 4.56276 0.0346289 6.87792 0 9.30209H0Z", fill: color }))));
};
//# sourceMappingURL=Loader.js.map